import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X5LessonType,
  X5LessonUpdateModel
} from '../../../../domain';
import {
  Control,
  HttpPromiseState,
  SaveStateHolder,
  StringControl,
  validators
} from '../../../../lib/helpers';

export class AddLessonStore implements SaveStateHolder {
  name: StringControl;
  lessonType: Control<X5LessonType | null>;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly unitId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.lessonType = new Control<X5LessonType | null>(
      'lesson type', null, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    this.lessonType.markTouched();
    if (this.name.invalid || this.lessonType.invalid)
      return;
    const model: X5LessonUpdateModel = {
      UnitId: this.unitId,
      LessonType: this.lessonType.value!,
      Name: this.name.value
    };
    this.save = contentLoaders.x5lesson.insert(model);
  }
}
